import React from 'react'
import PropTypes from 'prop-types'

const SearchIcon = ({ width = '16', height = '18', color = 'black' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.7533 15.8908C15.9113 16.0553 16 16.2783 16 16.5109C16 16.7435 15.9113 16.9665 15.7533 17.131C15.5954 17.2954 15.3812 17.3878 15.1579 17.3878C14.9345 17.3878 14.7203 17.2954 14.5624 17.131L10.442 12.8463C10.357 12.7646 10.2487 12.714 10.1336 12.7024C10.0184 12.6907 9.90277 12.7185 9.80422 12.7816C9.69092 12.87 9.57213 12.9505 9.44863 13.0226C8.24269 13.7399 6.84333 14.0232 5.46714 13.8289C4.09095 13.6345 2.81463 12.9732 1.83574 11.9474C0.856839 10.9216 0.229935 9.58836 0.0520383 8.15412C-0.125859 6.71987 0.155195 5.26454 0.851664 4.01338C1.54813 2.76222 2.62118 1.78497 3.90478 1.23288C5.18839 0.680786 6.61097 0.584634 7.95235 0.9593C9.29372 1.33397 10.4791 2.15856 11.3251 3.30547C12.171 4.45238 12.6304 5.85765 12.632 7.30381C12.6351 8.45522 12.3448 9.58688 11.791 10.5834C11.7279 10.7031 11.6582 10.8189 11.5822 10.9302C11.5163 11.0324 11.4856 11.1547 11.4948 11.2774C11.504 11.4 11.5527 11.5159 11.633 11.6061L15.7533 15.8908ZM6.31603 12.1292C7.23279 12.1304 8.12925 11.8484 8.89205 11.3189C9.65485 10.7893 10.2497 10.0361 10.6013 9.1545C10.9529 8.27287 11.0455 7.30245 10.8673 6.36603C10.6891 5.4296 10.2482 4.56925 9.60038 3.89381C8.95253 3.21838 8.12685 2.75822 7.22779 2.57155C6.32873 2.38489 5.39671 2.4801 4.54962 2.84515C3.70254 3.21021 2.97848 3.82868 2.46903 4.62234C1.95959 5.41601 1.68767 6.34918 1.68767 7.30381C1.68767 8.58257 2.17512 9.80905 3.04294 10.7138C3.91076 11.6186 5.08799 12.1277 6.31603 12.1292Z"
        fill={color}
      />
    </svg>
  )
}

export default React.memo(SearchIcon)

SearchIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
}
